import { render } from "./FormatBinding.vue?vue&type=template&id=760fc066"
import script from "./FormatBinding.vue?vue&type=script&lang=js"
export * from "./FormatBinding.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/configuration/FormatBinding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "760fc066"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('760fc066', __exports__)) {
    console.log('reload')
    api.reload('760fc066', __exports__)
  }
  
  module.hot.accept("./FormatBinding.vue?vue&type=template&id=760fc066", () => {
    console.log('re-render')
    api.rerender('760fc066', render)
  })

}


export default __exports__